export const translations = {
  optin: {
    title: {
      es: "Configuración de opt-in de reseñas",
      en: "Review opt-in settings"
    },
    description: {
      es: "Gestiona cómo tus clientes interactúan con el proceso de dejar reseñas.",
      en: "Manage how your customers interact with the review process."
    },
    optInLabel: {
      es: "Paso de opt-in con RAY antes de dejar reseña",
      en: "Opt-in with RAY before leaving a review"
    },
    enableAllStores: {
      es: "Activar opt-in en todas las tiendas",
      en: "Enable opt-in in all stores"
    },
    disableAllStores: {
      es: "Desactivar opt-in en todas las tiendas",
      en: "Disable opt-in in all stores"
    },
    modal: {
      title: {
        es: "¿Estás seguro de desactivar esta opción?",
        en: "Are you sure you want to disable this option?"
      },
      description: {
        es: "Al desactivar esta opción tus clientes van a ser redirigidos directamente a Google a dejar su reseña cuando escaneen los QRs de los empleados. Esto tiene algunos efectos secundarios indeseables:",
        en: "By disabling this option, your customers will be redirected directly to Google to leave their review when they scan employees' QRs. This has some undesirable side effects:"
      },
      list: {
        scans: {
          es: "Los <b>QR Scans</b> que ves en el Leaderboard se volverán <b>menos confiables</b>. Utilizamos el email obtenido del opt-in para asegurarnos unicidad de los scans, sin esa información dependemos de datos del dispositivo. Estos datos son menos confiables, no contabilizando scans válidos y también contabilizando scans inválidos.",
          en: "The <b>QR Scans</b> you see in the Leaderboard will become <b>less reliable</b>. We use the email obtained from the opt-in to ensure scan uniqueness; without it, we depend on device data, which is less reliable, missing valid scans and counting invalid ones."
        },
        sentiment: {
          es: "La <b>información de sentimiento</b> de las reseñas generadas por tu empleado o puntaje promedio de las mismas <b>no estará disponible</b>. ¡Esta información te puede ayudar mucho!",
          en: "The <b>sentiment information</b> of reviews generated by your employee or their average score <b>will not be available</b>. This information can be very helpful!"
        },
        login: {
          es: "Aunque desactives este paso, puede que el usuario tenga que hacer <b>login con Google</b> de todos modos. Esa fricción es inevitable y de no estar, nuestro opt-in es tan solo un click.",
          en: "Even if you disable this step, the user may still have to <b>log in with Google</b>. That friction is inevitable, and if not present, our opt-in is just one click."
        },
        marketing: {
          es: "<b>No obtendrás la información de tus clientes</b>, esta información podría servirte para hacer marketing en el futuro.",
          en: "<b>You will not get your customers' information</b>, which could be useful for future marketing."
        }
      },
      confirm: {
        es: "Entiendo y quiero desactivarla",
        en: "I understand and want to disable it"
      },
      keep: {
        es: "Dejar la opción activa",
        en: "Keep the option active"
      }
    }
  },
};